module.exports = __webpack_public_path__ + "img/OpenSea-Logo.23694606.png";